'use client';

import { useGetApiBackOfficeUsersCurrentUserDetail } from '@/api/backoffice/back-office-users/back-office-users';
import { Button } from '@/components/button';
import { GocoreLogoBallIcon } from '@/components/icons/GocoreLogoBallIcon';
import { useAuthDialog } from '@/context/AuthDialogProvider';

export const AuthenticationButtons = () => {
  const { toggleIsOpen } = useAuthDialog();

  const { data, error } = useGetApiBackOfficeUsersCurrentUserDetail({
    query: { staleTime: Number.POSITIVE_INFINITY },
  });

  if (data?.data && !error) {
    return (
      <Button
        aria-label={`Go to profile for ${data.data.userName}`}
        as="link"
        className="gap-2 truncate px-2 text-left"
        href="/profile"
        variant="primary"
      >
        <GocoreLogoBallIcon
          aria-hidden="true"
          className="h-6 w-6 text-black"
          desc="User profile logo icon"
          title="User Profile"
        />

        <span className="hidden max-w-44 truncate md:inline">
          {data.data.userName}
        </span>
      </Button>
    );
  }
  return (
    <div className="grid grid-cols-2 items-center gap-2 lg:flex lg:gap-4">
      <Button
        aria-label="Open login dialog"
        onClick={() => toggleIsOpen('sign-in')}
        variant="outline"
      >
        Login
      </Button>
      <Button
        aria-label="Open sign up dialog"
        glow
        onClick={() => toggleIsOpen('sign-up')}
        variant="primary"
      >
        Sign up
      </Button>
    </div>
  );
};
